// function updateSubmitButtonState(event) {
//   const checkbox = document.querySelector(".quick-cart__terms-checkbox input");
//   const submitButton = document.getElementById('cart-submit');
//   console.log(checkbox, submitButton, event.target);
//   submitButton.disabled = !checkbox.checked;
// }

// document.addEventListener('DOMContentLoaded', (event) => {
//   updateSubmitButtonState(event);
// });

// document.querySelector(".quick-cart__terms-checkbox input").addEventListener('change', (event) => {
//   updateSubmitButtonState(event);
// });

// window.addEventListener('load', () => {
//   handleCheckboxChange();
//   console.log("Script ran on window load.");
// });

//Custom element creation

class TermsCheckbox extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("input");
    console.log("Custom element connected.", this.input.checked);
    if (this.input) {
      this.input.addEventListener('change', () => this.handleCheckboxChange());
      this.handleCheckboxChange();
      window.addEventListener('load', () => {
        this.handleCheckboxChange();
        console.log("Script ran on window load.");
      });
    }
  }

  handleCheckboxChange() {
    const submitButton = document.getElementById('cart-submit');
    if (submitButton) {
      // submitButton.disabled = !this.input.checked;
      console.log('checked:', this.input.checked, this.input);
      if (this.input.checked) submitButton.removeAttribute('disabled');
      else submitButton.setAttribute('disabled', '');
      console.log(submitButton, submitButton.disabled);
    }
  }
}

customElements.define("quick-cart-checkbox", TermsCheckbox);
